import { Card, CardBody, Row, Col } from "reactstrap"
import { formatReadableDate, formatSinceDate } from "utils/formatDate"
import ProfileHeader from "./ProfileHeader"
import ProfileInfoItem from "./ProfileInfoItem"
import ProfileSkeleton from "./ProfileSkeleton"

const ProfileCard = ({
  data,
  loading = false,
  onCustomer,
}) => {
  if (loading) return <ProfileSkeleton />
  if (!data) return null

  const {
    name,
    cuid,
    mobile,
    email,
    full_address,
    customer_type,
    created_at,
    designation,
    department,
    company,
    area,
    city,
  } = data

  const handleFromDb = value => {
    if (typeof value === "object" && value && "name" in value) {
      return value.name
    }
    return value
  }

  const location =
    handleFromDb(area) || handleFromDb(city)
      ? [handleFromDb(area), handleFromDb(city)].filter(Boolean).join(", ")
      : "-"

  const infoItems = [
    { icon: "bx bx-phone", label: "Mobile", value: mobile },
    { icon: "bx bx-envelope", label: "Email", value: email },
    {
      icon: "bx bx-buildings",
      label: "Company",
      value: handleFromDb(company),
    },
    {
      icon: "bx bx-group",
      label: "Department",
      value: handleFromDb(department),
    },
    { icon: "bx bx-map", label: "Location", value: location },
    { icon: "bx bx-home-alt", label: "Address", value: full_address },
  ]

  return (
    <Card className="shadow-sm border-0 rounded-lg">
      <CardBody className="p-4">
        <ProfileHeader
          name={name}
          cuid={cuid ?? "Pending ID"}
          designation={handleFromDb(designation)}
          customer_type={handleFromDb(customer_type)}
          editData={data}
          onCustomer={onCustomer}
        />

        <Row className="g-3">
          {infoItems.map((item, index) => (
            <Col xs={12} sm={6} key={index}>
              <ProfileInfoItem {...item} />
            </Col>
          ))}

          {created_at && (
            <Col xs={12}>
              <div className="d-flex align-items-start pt-2 border-top">
                <i className="bx bx-calendar text-muted mt-1 me-2 fs-6"></i>
                <div>
                  <div className="small text-muted d-block small">
                    Member Since
                  </div>
                  <div>{formatReadableDate(created_at)}</div>
                  <div className="small text-muted fst-italic">
                    {formatSinceDate(created_at)}
                  </div>
                </div>
              </div>
            </Col>
          )}
        </Row>
      </CardBody>
    </Card>
  )
}

export default ProfileCard
